<div class="modal-header">
    <h4 class="modal-title pull-left">Duplicate Properties</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
        <div class="table-responsive">
            <!--<div>
                <input class="form-control be-input margin-bottom-20" [(ngModel)]="searchValue" (keyup)="onSearch(searchValue)" maxlength="200" placeholder="Search Tenant">
            </div>-->
            <table class="table basictable row-border hover duplicate-list" id="dtTableDuplicates" datatable [dtOptions]="dtOptions">
                <tbody>
                    <tr *ngFor="let prop of duplicatePropertyList;let i = index ">
                        <td>
                            <div class="modal-data-box">
                                <h4 style="font-weight:600;">
                                    <label class="custom-checkbox withoutlabel" *ngIf="allowMerge">
                                        <input type="checkbox" [(ngModel)]="prop.IsSelected" class="ng-pristine ng-valid ng-touched"><i></i>
                                    </label>

                                    <a href="javascript:void(0);" *ngIf="prop.Type == 1" routerLink="/viewproperty/{{prop.Slug ? prop.Slug : prop.PropertyGuid}}"  [queryParams]="{prevroute:this.prevRoute==null?prop.Status:this.prevRoute,link:this.prevRoute==null?prop.RedirectURL:prevLink}" (click)="modalRef.hide()">{{prop.TenantName}}</a>
                                    <a href="javascript:void(0);" *ngIf="prop.Type == 2" routerLink="/viewdeproperty/{{prop.Slug ? prop.Slug : prop.PropertyGuid}}" [queryParams]="{prevroute:this.prevRoute==null?prop.Status:this.prevRoute,link:this.prevRoute==null?prop.RedirectURL:prevLink}" (click)="modalRef.hide()">{{prop.TenantName}}</a>
                                   
                                </h4>
                                <!--<p>
                                    <span class="tag" [ngClass]="{'redtext':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentext':prop.PropertyStatus === 'Available','gerytext':prop.PropertyStatus === 'Under Contract','ashtext':prop.PropertyStatus === 'Off-Market'}">
                                        {{prop.PropertyStatus}}
                                    </span>
                                </p>-->
                                <p class="margin-bottom-10 margin-top-10">
                                    <span class="tag graytextlabel" [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract','not-available':prop.PropertyStatus === 'Not Available','Off-Market':prop.PropertyStatus === 'Off-Market'}">
                                        {{prop.PropertyStatus}}
                                    </span>    
                                </p>
                                <p>{{prop.State}},{{prop.City}}</p>
                                <p>
                                    <span class="tag" [ngClass]="{'greentext':prop.Type == 1,'ashtext':prop.Type == 2 }">
                                        {{prop.Status}}
                                    </span>
                                </p>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr *ngIf="duplicatePropertyList?.length == 0 ">
                        <td colspan="15" class="odd no-data-available">
                            <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="text-right" *ngIf="allowMerge">
            <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>
            <button class="btn btn-success btn-lg" (click)="mergeProperties();">Merge</button>
        </div>
    </div>
</div>
